import { gsap } from 'gsap';

/*
* cc-stageMissionStatement
*/

const ccSliderVerticalSticky = {
    cfg:  {
        name: 'Slider Vertical Sticky +',
        selectors: {
            root: '.cc-stageMissionStatement',
        },
        classes: {
        },
        el: {
            $root: undefined,
        },
        gsapDefaults: {
            duration: 1,
            stagger: 0.1,
            ease: 'power3.out',
        },
    },

    setElements() {
        this.cfg.el.$root = document.querySelector(this.cfg.selectors.root);
    },

    addEventListeners() {
        const bgEl = this.$('bg')[0];
        const items = this.$('item');
        const introTexts = [...this.$('intro')];
        const copy = this.$('copy')[0];
        const headline = this.$('headline')[0];
        const diamond = this.$('diamond')[0];
        const stage = document.querySelector('.cc-stageHero__container');

        for (const el of [...introTexts, diamond, headline, copy]) {
            // Add text wrapper div around each element
            el.className += ' js-wrapText';
            const inner = document.createElement('div');
            inner.className = 'js-wrapTextInner';
            const nodes = [...el.childNodes];
            for (const node of nodes) {
                inner.appendChild(node);
            }
            el.appendChild(inner);
        }

        gsap.set(items[0], { yPercent: 0 });
        gsap.timeline({
            scrollTrigger: {
                trigger: bgEl,
                // when the top of the container hits the center of the viewport
                start: "top center",
                // when the top of the container hits the top of the viewport
                end: () => `top top-=${items[0].offsetHeight}px`,
                scrub: true,
                pin: items[0],
                pinSpacing: false,
                onLeave() {
                    stage.style.display = 'none';
                },
                onEnterBack() {
                    stage.style.display = 'block';
                },
            }
        }).to(bgEl, {
            scale: 1.5,
        })
        .to(items[0], {
            y: () => (items[0].offsetHeight - (window.innerHeight * .75)) / 2,
        }, 0 /* transform in parallel to scale */);

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: items[1],
                start: "33% center",
                // markers: true, // Show markers for debugging
                // container+=... extends the duration of the animation
                end: () => `center+=${window.innerHeight * .15} top`,
                // smooth that timeline's scroll binding
                scrub: 1,
                pin: true,
            },
            defaults: this.cfg.gsapDefaults,
        });

        let tlOrder = 1;
        for (const el of introTexts) {
            tl.to(el.firstChild, {
                yPercent: -125,
            }, 0.25 * tlOrder++);
        }

        for (const el of [diamond, headline, copy]) {
            gsap.set(el.firstChild, { yPercent: 125 });
            tl.to(el.firstChild, {
                yPercent: 0,
            }, tlOrder++);
        }
    },

    init() {
        console.debug(`Init: ${this.cfg.name}`);
        this.setElements();

        if (this.cfg.el.$root) {
            this.addEventListeners();
        }
    },

    $(bemId) {
        return this.cfg.el.$root.querySelectorAll(`${this.cfg.selectors.root}__${bemId}`);
    }
};

export default ccSliderVerticalSticky;
